export default {
  route: {
    '密码计算': 'Calcul Cryptographique',
    '公告': 'Annonce',
    '公告详情': "Détails De L'annonce",
    '在线考试': 'Examen En Ligne',
    '考试记录': "Dossiers D'examen",
    '证书信息': 'Informations Certificat',
    '证书统计': 'Statistiques De Certificat',
    '公告管理': 'Gestion Des Annonces',
    '培训视频': 'Vidéo De Formation',
    '培训视频管理': 'Gestion Vidéos Formation',
    '视频标签管理': 'Gestion Balises Vidéo',
    '题库管理': 'Banque Questions',
    '单选题库管理': 'Radio',
    '多选题库管理': 'Choix Multiple',
    '判断题库管理': 'Juge',
    '用户管理': 'Gestion Des Utilisateurs',
    '组织管理': "Gestion De L'organisation",
    '角色管理': 'Gestion Des Rôles',
    '功能管理': 'Gestion Des Fonctions',
    '设备信息': "Informations Sur L'appareil",
    '经销商信息': 'Informations Revendeur',
    '经销商-设备': 'Concessionnaire-Équipement',
    '经销商-设备关联': 'Revendeur-Appareil',
    '设备关联': "Association D'appareils",
    '经销商-账号关联': 'Concessionnaire-Compte',
    '系统字典': 'Dictionnaire Système',
    '算号记录': "Numéro D'enregistrement",
    '账户管理': 'Gestion De Compte',
    '技术文档资料库': 'Documentation Technique',
    '员工权限': 'Autorisations Personnel',
    '考试培训': 'Formation Aux Examens',
    '系统管理': 'La Gestion Du Système'
  },
  lang: {
    '认证经销商服务平台': 'Plate-forme De Service Des Revendeurs Certifiés',
    '用户名': "Nom D'utilisateur",
    '密码': 'Mot De Passe',
    '登录': 'Connexion',
    '当前版本': 'Version Actuelle',
    '请输入用户名': "Veuillez Entrer D'utilisateur",
    '请输入密码': 'Veuillez Entrer Passe',
    '您的密码强度太低，请尽快修改密码': 'La force de votre mot de passe est trop faible, veuillez changer votre mot de passe dès que possible',
    '修改密码': 'Changer Passe',
    '修改头像': "Modifier L'avatar",
    '原始密码': "Mot Passe D'origine",
    '新密码': 'Nouveau Mot Passe',
    '可选择': 'Facultatif',
    '确认新密码': 'Confirmez le nouveau mot de passe',
    '请输入原始密码': "Veuillez entrer le mot de passe d'origine",
    '两次输入密码不一致': 'Les mots de passe entrés deux fois sont incohérents',
    '请输入新密码': 'Veuillez entrer un nouveau mot de passe',
    '请输入不少于6位的密码': "Veuillez entrer un mot de passe d'au moins 6 caractères",
    '修改成功,请重新登录!': 'La modification a réussi, veuillez vous reconnecter !',
    '修改失败!': 'Ne pas éditer !',
    '请上传正确的图片格式（jpge/jpg/png/gif）': "Veuillez télécharger le format d'image correct (jpge/jpg/png/gif)",
    '图片大小超过1M，请重新选择!': "La taille de l'image dépasse 1M, veuillez choisir à nouveau !",
    '图片命名中包含特殊字符，请规正命名再上传!': "Le nom de l'image contient des caractères spéciaux, veuillez corriger le nom avant de le télécharger !",
    '请选择头像上传': 'Veuillez sélectionner un avatar à télécharger',
    '更改头像成功!': 'Avatar changé avec succès',
    '更改头像失败!': "Échec du changement d'avatar ",
    '取消': 'Annuler',
    '确认': 'Confirmer',
    '操作': 'Fonctionner',
    '编辑': 'Modifier',
    '启用中': 'Actif',
    '禁用中': 'Désactivé',
    '编辑菜单': "Menu D'édition",
    '编辑功能': "Fonction D'édition",
    '添加功能': 'Ajouter Une Fonction',
    '您已修改状态为 --> 禁用': 'Vous avez modifié le statut en --> Désactivé',
    '您已修改状态为 --> 启用': 'Vous avez modifié le statut en --> Activé',
    '添加成功': 'Ajouté avec succès',
    '添加失败': "échec de l'ajout",
    '编辑成功': 'Modifié avec succès',
    '编辑失败': 'échec de la modification',
    '请选择': "Choisissez s'il vous plaît",
    '状态': 'État',
    '作废': 'Annuler',
    '功能': 'Fonction',
    '请输入功能名称': 'Veuillez entrer un nom de fonction',
    '功能名': 'Nom De La Fonction',
    '请输入功能': 'Veuillez entrer la fonction',
    '功能url': 'URL De La Fonction',
    '请输入功能url': "Veuillez saisir l'URL de la fonction",
    '菜单/功能': 'Menu/Fonction',
    '菜单': 'Menu',
    '请输入菜单': 'Veuillez entrer dans le menu',
    '菜单名': 'Nom Du Menu',
    '请输入菜单名': 'Veuillez entrer un nom de menu',
    '是否必选': 'Est-Ce Obligatoire',
    '添加菜单': 'Ajouter Un Menu',
    '父级菜单': 'Menu Parent',
    '是': 'Oui',
    '否': 'Non',
    '启用': 'Activer',
    '禁用': 'Désactivé',
    '状态修改失败': 'La modification du statut a échoué',
    '请选择功能': 'Veuillez sélectionner une fonction',
    '查询': 'Renseigner',
    '添加': 'Ajouter A',
    '组织': 'Organiser',
    '父级组织': 'Organisation Mère',
    '请输入组织名称': "Veuillez entrer un nom d'organisation",
    '类型': 'Taper',
    '地址': 'Adresse',
    '添加组织': 'Ajouter Une Organisation',
    '编辑组织': 'Organisation Editoriale',
    '名称': 'Nom',
    '该组织名称已存在': "Le nom de l'organisation existe déjà",
    '获取组织根节点列表失败': "Impossible d'obtenir la liste des nœuds racine de l'organisation",
    '请选择组织': 'Veuillez sélectionner une organisation',
    '角色': 'Rôle',
    '请输入角色名称': 'Veuillez entrer un nom de rôle',
    '序号': 'Numéro De Série',
    '所属组织': 'Organisation',
    '请输入': "Entrez s'il vous plait",
    '输入用户名': "Entrez votre nom d'utilisateur",
    '重置密码': 'Réinitialiser le mot de passe',
    '姓名': 'Nom',
    '确认密码': 'Confirmez le mot de passe',
    '邮箱': 'Poster',
    '用户名中不能有空格': "Le nom d'utilisateur ne peut pas contenir d'espaces",
    '请输入不少于4位的用户名': "Veuillez entrer un nom d'utilisateur avec pas moins de 4 caractères",
    '该用户名已存在': 'Cet identifiant existe déjà',
    '请输入姓名': 'Veuillez saisir votre nom',
    '请确认密码': 'Veuillez confirmer votre mot de passe',
    '两次填写的密码不一致': 'Les mots de passe entrés deux fois sont incohérents',
    '请选择角色': 'Veuillez sélectionner un rôle',
    '请输入正确的邮箱地址': 'Veuillez saisir la bonne adresse e-mail',
    '创建时间': 'Temps Creation',
    '最近修改时间': 'Heure Dernière Modification',
    '最近登录时间': 'Heure Dernière Connexion',
    '识别码': 'Identifiant',
    '经销商编号': 'Numéro Revendeur',
    '型号': 'Modèle',
    '修改时间': "Changer L'heure",
    '备注': 'Remarque',
    '批量添加': 'Ajouter Par Lots',
    '导出': 'Exporter',
    '退出登录': 'Se Déconnecter',
    '流水号': 'Numéro Série',
    '流水号/注册编号': "Numéro de série/numéro d'enregistrement",
    '请输入流水号/注册编号': "Veuillez entrer le numéro de série/numéro d'enregistrement",
    '绑定密码': 'Lier Le Mot De Passe',
    'TG密码': 'Password For【Setup】',
    '探棒设置密码': 'Password For【Probe Setup】',
    '自定义期限密码': 'Password For 【Customised Duration】',
    '永久期限密码': 'Password For 【Permanent Key】',
    '1个月密码': 'Password For 【1 Mth Effective Key】',
    '2个月密码': 'Password For 【2 Mth Effective Key】',
    '3个月密码': 'Password For 【3 Mth Effective Key】',
    '液位仪密码': 'Password For【Liquid Level Meter】',
    '请输入流水号': 'Veuillez entrer le numéro de série',
    '计算失败': 'Le calcul a échoué',
    '登录失败': 'Echec de la connexion',
    '请先选择类型': "Veuillez d'abord sélectionner le type",
    '取消space': 'Annuler',
    '确定space': 'Bien Sûr',
    '将文件拖到此处，或': 'Faites glisser les fichiers ici, ou',
    '点击上传': 'Cliquez pour télécharger',
    '只能上传xlsx/xls文件，且不超过500kb': 'Seuls les fichiers xlsx/xls peuvent être téléchargés, et pas plus de 500 Ko',
    '模板': 'Modèle',
    '保存': 'Sauvegarder',
    '请输入识别码': "Veuillez entrer le code d'identification",
    '识别码已存在': "L'identifiant existe déjà",
    '请选择型号': 'Veuillez sélectionner un modèle',
    '请选择类型': 'Veuillez choisir le type',
    '确认作废此数据?': 'Confirmer pour annuler ces données?',
    '提示': 'Indice',
    '确定': 'Bien sûr',
    '作废成功': 'Annuler Avec Succès',
    '作废失败': "Échec De L'annulation",
    '当前限制选择 1 个文件': 'Limite actuelle pour sélectionner 1 fichier',
    '请选择文件': 'Veuillez sélectionner un fichier',
    '批量添加成功': 'Lot ajouté avec succès',
    '批量添加失败': "Échec de l'ajout par lots",
    '设备信息批量导入模板': "Modèle d'importation par lots d'informations sur l'appareil",
    '设备信息': "Informations sur l'appareil",
    '关联设备url': "URL L'appareil Associé",
    '编号': 'Numéro Série',
    '国家或地区': 'Pays Ou Région',
    '联系人': 'Personne Contact',
    '电话': 'Téléphone',
    '复制': 'Copie',
    '关闭': 'Fermeture',
    '请输入名称': 'Veuillez Entrer Un Nom',
    '名称已存在': 'Le Nom Existe Déjà',
    '请输入国家或地区': 'Veuillez entrer un pays ou une région',
    '获取url失败': "Impossible d'obtenir l'URL",
    '复制成功': 'Copier Avec Succès',
    '经销商信息': 'Informations Sur Le Revendeur',
    '经销商': 'Marchand',
    '设备识别码': "Reference de l'appareil",
    '审核': 'Examen',
    '审核结果': 'Résultats Des Audits',
    '审核意见': "Avis D'audit",
    '审核备注': "Remarques Sur L'examen",
    '请选择经销商': 'Veuillez Sélectionner Un Revendeur',
    '请选择审核结果': "Veuillez sélectionner le résultat de l'examen",
    '请输入审核意见': 'Veuillez entrer des commentaires de révision',
    '同意': 'Accepter',
    '不同意': 'Etre En Désaccord',
    '审核成功': 'Audit Réussi',
    '审核失败': "Échec De L'audit",
    '有效': 'Efficace',
    '失效': 'Echouer',
    '经销商设备关联': "Association Revendeurs D'appareils",
    '请输入设备识别码': "Veuillez entrer l'ID de l'appareil",
    '当前账号未绑定经销商，请联系管理员绑定': "Le compte courant n'est pas lié à un revendeur, veuillez contacter l'administrateur pour le lier",
    '设备关联': "Association D'appareils",
    '账号': 'Compte',
    '请选择账号': 'Veuillez sélectionner un compte',
    '经销商账号关联': 'Association Compte Revendeur',
    '参数键': 'Clé Paramètre',
    '级参数': 'Paramètres Classe',
    '参数值': 'Valeur Du Paramètre',
    '请输入参数键': 'Veuillez entrer la clé de paramètre',
    '参数键已存在': 'La clé de paramètre existe déjà',
    '所有语言参数值 都不能为空': 'Toutes les valeurs des paramètres de langue ne peuvent pas être vides',
    '经销商名称': 'Le nom du revendeur',
    '算号记录': "Numéro d'enregistrement",
    '操作人员': 'Opérateur',
    '序号不能为空': 'Le numéro de série ne peut pas être vide',
    '序号必须为正数': 'Le numéro de série doit être un nombre positif',
    '添加角色': 'Ajouter Un Rôle',
    '编辑角色': 'Modifier Le Rôle',
    '该角色将被删除, 是否继续?': 'Le rôle sera supprimé, continuer ?',
    '添加用户': 'Ajouter Utilisateur',
    '查询失败': 'La requête a échoué',
    '编辑用户': "Modifier l'utilisateur",
    '此操作将重置': 'Cette action réinitialisera ',
    '用户密码为': ' le mot de passe utilisateur est',
    ', 是否继续?': ', Que ce soit pour continuer?',
    '重置成功': 'Réinitialisation Réussie',
    '重置失败': 'Échec De La Réinitialisation',
    '已取消重置': 'Réinitialisation Annulée',
    '数据加载中': 'Chargement...',
    '上滑查看更多': 'Balayez vers le haut pour en voir plus',
    '没有更多了': 'Pas Plus',
    '暂无数据': 'Pas De Données',
    '无权限': ' aucune autorisation',
    '未登录': 'Pas Connecté',
    '服务器未启动/响应错误': 'Le serveur ne démarre pas /Ne répond pas avec une erreur',
    '菜单查询': 'Requête De Menu',
    '设置列': 'Définir Des Colonnes',
    '地址错误，请检查': "L'adresse est erronée, veuillez vérifier",
    '澳科设备认证平台': 'Plateforme de certification des équipements Autech',
    '欢迎您使用澳科设备绑定功能': "Bienvenue à utiliser la fonction de liaison de l'appareil Autech",
    '绑定': 'Lier',
    '获取经销商信息失败': "Échec de l'obtention des informations sur le concessionnaire",
    '未获取到经销商信息，请刷新页面': 'Informations sur le concessionnaire non obtenues, veuillez actualiser la page',
    '绑定成功': 'Lier avec succès',
    '绑定失败': 'La liaison a échoué',
    '版权所有': 'Tous les droits sont réservés',
    '青岛澳科仪器有限责任公司': 'Qingdao Oket Instrument Co., Ltd.',
    '关闭其它': 'Fermer Autre',
    '关闭所有': 'Ferme Tout',
    '对应设备已存在': "L'appareil correspondant existe déjà",
    '文件': 'Document',
    '下载': 'Télécharger',
    '液位仪安装验收单': "Formulaire d'acceptation d'installation de compteur de niveau de liquide",
    '测漏安装验收单': "Formulaire d'acceptation d'installation de test de fuite",
    '安装工具清单': "Liste des outils d'installation",
    '维护': 'Maintenir',
    '操作维护指南': "Guide d'utilisation et d'entretien",
    '加油站': 'Station-Essence',
    '请输入加油站': 'Veuillez entrer la station-service',
    '请先选择经销商': "Veuillez d'abord sélectionner un revendeur",
    '员工': 'Personnel',
    '可计算密码类型': 'Type de mot de passe calculable',
    '请选择员工': 'Veuillez sélectionner un employé',
    '该员工已添加': "L'employé a été ajouté",
    '请选择设备识别码': "Veuillez sélectionner un ID d'appareil",
    '请选择可计算密码类型': 'Veuillez sélectionner un type de mot de passe calculable',
    '该经销商未关联用户': "Ce revendeur n'a pas d'utilisateurs associés",
    '客服销售人员': 'Vendeur Service Client',
    '管理员': 'Administrateur',
    '无此密码类型': 'Aucun type de mot de passe de ce type',
    bullshit_info: "Veuillez vérifier que l'URL que vous avez saisie est correcte, veuillez cliquer sur le bouton ci-dessous pour revenir à la page d'accueil ou envoyer un rapport d'erreur",
    return_home: 'Retour au centre personnel',
    cant_in: 'Le webmaster dit que vous ne pouvez pas accéder à cette page......',
    advice: "Afin de vous apporter une meilleure expérience, nous vous recommandons fortement d'utiliser le mode vitesse extrême ou le navigateur Chrome",
    // 后端
    '暂未登录或token已经过期': 'Pas encore connecté ou le jeton a expiré'
  },
  fun: {
    '公告': 'Annonce',
    '公告详情': "Détails De L'annonce",
    '在线考试': 'Examen En Ligne',
    '考试记录': "Dossiers D'examen",
    '证书信息': 'Informations Certificat',
    '证书统计': 'Statistiques De Certificat',
    '公告管理': 'Gestion Des Annonces',
    '培训视频': 'Vidéo De Formation',
    '培训视频管理': 'Gestion Des Vidéos Formation',
    '视频标签管理': 'Gestion Des Balises Vidéo',
    '题库管理': 'Banque Questions',
    '单选题库管理': 'Radio',
    '多选题库管理': 'Choix Multiple',
    '判断题库管理': 'Juge',
    '用户权限': "Droits De L'utilisateur",
    '用户管理': 'Gestion Des Utilisateurs',
    '组织管理': "Gestion De L'organisation",
    '角色管理': 'Gestion Des Rôles',
    '功能管理': 'Gestion Des Fonctions',
    '设备信息': "Informations Sur L'appareil",
    '经销商信息': 'Informations Sur Le Revendeur',
    '经销商-设备关联': 'Association Revendeur-Appareil',
    '经销商-账号关联': 'Association Concessionnaire-Compte',
    '系统字典': 'Dictionnaire Système',
    '算号记录': "Numéro D'enregistrement",
    '设备关联': "Association D'appareils",
    '密码计算': 'Calcul Cryptographique',
    '查询设备全部': 'Interroger Tous Les Appareils',
    'App': 'App',
    'getInfo': 'getInfo',
    '分页查询设备': 'Dispositif Requête Pagination',
    '添加设备信息': "Ajouter des informations sur l'appareil",
    '更新设备信息': "Mettre à jour les informations sur l'appareil",
    '设备作废': 'Equipement Obsolète',
    '设备识别码判重': "Jugement du code d'identification de l'appareil",
    '分页查询经销商': 'Rechercher des revendeurs par page',
    '查询设备经销商全部': "Interroger tous les revendeurs d'équipements",
    '添加经销商信息': 'Ajouter des informations sur le concessionnaire',
    '更新经销商信息': 'Mettre à jour les informations du concessionnaire',
    '经销商信息作废': 'Les informations du distributeur ne sont pas valides',
    '经销商名称、编号判重': 'Nom du distributeur et numéro de série',
    '获取当前用户的经销商': "Obtenir le revendeur de l'utilisateur actuel",
    '分页查询经销商设备关联': "Interroger l'association d'équipements des concessionnaires par page",
    '查询经销商设备关联全部': "Interroger l'association d'équipement des concessionnaires tous",
    '添加经销商设备关联信息': "Ajouter des informations sur l'association d'équipement du concessionnaire",
    '更新经销商设备关联信息': "Mettre à jour les informations de l'association d'équipement des concessionnaires",
    '经销商设备关联作废': "L'association d'équipement du revendeur n'est pas valide",
    '经销商-设备关联查询设备全部': "Requête de l'association concessionnaire-équipement tout équipement",
    '经销商-设备关联查询设备经销商全部': "L'association de concessionnaires d'équipement interroge tous les concessionnaires d'équipement",
    '经销商-设备关联分页查询经销商设备关联': "Page d'association revendeur-appareil requête association d'équipement revendeur",
    '经销商-设备关联查询经销商设备关联全部': 'Dealer-Equipment Association Requête Dealer Equipment Association Tous',
    '经销商-设备关联添加经销商设备关联信息': "Association revendeur-appareil Ajouter des informations sur l'association de l'appareil revendeur",
    '经销商-设备关联更新经销商设备关联信息': "Mise à jour de l'association revendeur-appareil Informations sur l'association de l'appareil revendeur",
    '经销商-设备关联经销商设备关联作废': "Association de concessionnaires d'équipementsL'association d'équipements de concessionnaires n'est pas valide",
    '经销商设备关联审核': "Examen de l'association des revendeurs d'équipements",
    '分页查询经销商账号关联': "Interroger l'association du compte du concessionnaire par page",
    '查询经销商账号关联全部': "Interroger l'association du compte du concessionnaire tous",
    '添加经销商账号关联信息': 'Ajouter des informations associées au compte du concessionnaire',
    '更新经销商账号关联信息': 'Mettre à jour les informations associées au compte du concessionnaire',
    '经销商账号关联作废': "Annulation de l'association de compte distributeur",
    '经销商-账号关联获取所有得用户列表': "Association revendeur-compte pour obtenir toutes les listes d'utilisateurs",
    '经销商-账号关联查询设备经销商全部': "Concessionnaire-Account Association Requête Concessionnaire d'appareils Tous",
    '右上角添加/修改用户': 'Ajouter/modifier des utilisateurs dans le coin supérieur droit',
    '用户头像-上传本地': "Avatar d'utilisateur - Télécharger local",
    '用户密码修改': 'Modification du mot de passe utilisateur',
    '分页查询组织': 'Organisation des requêtes de pagination',
    '添加组织': 'Ajouter Une Organisation',
    '编辑组织': 'Organisation Editoriale',
    '校验组织是否存在': "Vérifier si l'organisation existe",
    '查询角色列表': 'Interroger la liste des rôles',
    '删除角色': 'Supprimer Le Rôle',
    '角色查询所有得权限': 'Rôle interroger toutes les autorisations',
    '添加/编辑角色': 'Ajouter/modifier un rôle',
    '组织根节点列表': "Liste des nœuds racine de l'organisation",
    '查询所有得权限': 'Interroger toutes les autorisations',
    '获取所有的菜单': 'Obtenir tous les menus',
    '添加/编辑权限': 'Ajouter/modifier des autorisations',
    '获取所有得用户列表': 'Obtenir une liste de tous les utilisateurs',
    '添加/修改用户': 'Ajouter/modifier un utilisateur',
    '用户密码重置': 'Réinitialisation du mot de passe utilisateur',
    '用户是否存在': "L'utilisateur existe-t-il",
    '获取算号': 'Compter',
    '查询全部算号': 'Interroger tous les numéros de calcul',
    '分页查询算号': 'Numéro de calcul de la requête de pagination',
    '获取关联设备的url': "Obtenir l'url de l'appareil associé",
    '分页查询系统字典项(树形)': 'Éléments du dictionnaire du système de requête de pagination (arborescence)',
    '查询所有系统字典项-列表': 'Interroger toutes les entrées du dictionnaire système - liste',
    '查询系统字典类型': 'Type de dictionnaire du système de requête',
    '添加系统字典': 'Ajouter un dictionnaire système',
    '编辑系统字典': 'Modifier le dictionnaire système',
    '查询下一级系统字典项': 'Interroger les éléments du dictionnaire système de niveau suivant',
    '校验参数键是否重复': 'Vérifiez si la touche de paramètre est répétée',
    '设备查询下一级系统字典项': "L'appareil interroge les éléments du dictionnaire système de niveau suivant",
    '批量导入设备信息': "Informations sur l'appareil d'importation par lots",
    '技术文档资料库': 'Base de données de documentation technique',
    '技术文档资料库界面': 'Interface de la base de données de documentation technique',
    '更新设备信息admin': "Mettre à jour l'administrateur des informations sur l'appareil",
    '更新设备信息noadmin': "Mettre à jour les informations de l'appareil noAdmin",
    '员工权限': 'Autorisations du personnel',
    '查询当前用户组织下可查看角色': "Interroger les rôles disponibles dans l'organisation de l'utilisateur actuel",
    '查询算号记录算密码类型': "Type de mot de passe de calcul d'enregistrement de calcul de numéro de requête",
    '查询密码计算算密码类型': 'Demander le calcul du mot de passe calculer le type de mot de passe',
    '查询当前用户角色': "Interroger le rôle d'utilisateur actuel",
    '查询员工权限算密码类型': "Interroger l'autorité des employés et calculer le type de mot de passe",
    '分页查询员工权限': 'Interroger les autorisations des employés par page',
    '查询员工权限全部': 'Interroger toutes les autorisations des employés',
    '添加员工权限': "Ajouter des autorisations d'employé",
    '编辑员工权限': 'Modifier les autorisations des employés',
    '校验经销商员工关系是否唯一': "Vérifiez que la relation d'employé du concessionnaire est unique",
    '员工权限作废': "Annulation de l'autorité des employés",
    '查询指定用户组织下的用户': "Interroger les utilisateurs sous l'organisation d'utilisateurs spécifiée",
    '员工权限查询经销商设备关联全部': "Requête d'autorisation d'employé Association d'équipement de concessionnaire tous",
    '员工权限获取所有得用户列表': "Autorisation des employés pour obtenir toutes les listes d'utilisateurs",
    '员工权限获取当前用户的经销商': "Autorisations des employés Obtenir les revendeurs de l'utilisateur actuel",
    '员工权限查询设备经销商全部': "Demande d'autorisation des employés concessionnaires d'équipement tous",
    '员工权限查询经销商账号关联全部': "Demande d'autorisation d'employé Compte de concessionnaire associé à tous",
    '用户管理查询当前用户角色': "La gestion des utilisateurs demande le rôle d'utilisateur actuel",
    '获取全部国家和地区': 'Obtenez tous les pays et régions',
    '公告分页': "Page d'annonce",
    '阅读公告': "Lire l'annonce",
    '公告（详情）': 'Annonce (détails)',
    '公告分页（管理）': 'Onglet Annonces (gestion)',
    '添加公告': 'Ajouter Une Annonce',
    '编辑公告': 'Annonce Editoriale',
    '删除公告': "Supprimer l'avis",
    '新增试卷（考试）': 'Nouvelle épreuve (examen)',
    '试卷内容': 'Tester le contenu du papier',
    '提交试卷': 'Soumettre le papier test',
    '试卷分页（考试记录）': "Pagination des copies de test (dossiers d'examen)",
    '用户列表': "Liste d'utilisateur",
    '新增试卷': 'Nouveau papier test',
    '证书分页': 'Pagination du certificat',
    '用户列表（证书）': "Liste d'utilisateurs (certificat)",
    '培训视频分页': 'Pagination des vidéos de formation',
    '培训视频标签分页（视频）': "Pagination de l'onglet Vidéos de formation (Vidéos)",
    '培训视频分页（管理）': 'Pagination des vidéos de formation (Gestion)',
    '添加培训视频': 'Ajouter une vidéo de formation',
    '编辑培训视频': 'Modifier la vidéo de formation',
    '删除培训视频': 'Supprimer la vidéo de formation',
    '培训视频标签分页（管理）': "Pagination de l'onglet Vidéos de formation (Gestion)",
    '培训视频标签分页': "Pagination de l'onglet Vidéos de formation",
    '添加培训视频标签': 'Ajouter une balise de vidéo de formation',
    '编辑培训视频标签': 'Modifier les balises des vidéos de formation',
    '删除培训视频标签': 'Supprimer les balises des vidéos de formation',
    '题目列表分页(单选)': 'Pagination de la liste des sujets (choix unique)',
    '新增题目（单选）': 'Ajouter un sujet (choix unique)',
    '删除题目（单选）': 'Supprimer le sujet (choix unique)',
    '题目列表分页（多选）': 'Pagination de la liste des sujets (choix multiples)',
    '新增题目（多选）': 'Ajouter un sujet (choix multiple)',
    '删除题目（多选）': 'Supprimer le sujet (choix multiple)',
    '题目列表分页（判断）': 'Pagination de la liste des sujets (jugement)',
    '新增题目（判断）': 'Ajouter un nouveau sujet (jugement)',
    '删除题目（判断）': 'Supprimer le sujet (jugement)',
    '考试培训': 'Formation Aux Examens',
    '系统管理': 'La Gestion Système',
    '证书下载': 'Téléchargement Certificat',
    '证书下载（考试记录）': "Téléchargement du certificat (dossier d'examen)",
    '证书分页（统计）': 'Pagination du certificat (Statistiques)',
    '用户列表（统计）': "Liste d'utilisateurs (statistiques)",
    '证书下载（统计）': 'Téléchargement du certificat (statistiques)'
  },
  file: {
    'ATG系列文档': 'ATG Series Documents',

    'ATG操作手册': 'ATG Operation Manual',
    '1-1-3-1-1': "1-1-3-1-1 PD-350+ Networking Tank-eye Operator's Manual V1.5-20250528",
    '1-1-3-1-2': '1-1-3-1-2 PD-350 & PD-350+ Series Console Operator’s Manual 20250520',
    '1-1-3-1-4': '1-1-3-1-4 MC-6 Explosion proof Console Operator’s Manual V2.0',
    '1-1-3-1-5': '1-1-3-1-5 OKet Console Quick Start Guide (20250519)',
    '1-1-3-1-6': '1-1-3-1-6 OKet Guide de Démarrage 20250522',
    '1-1-3-1-7': '1-1-3-1-7 OKet Guía de Inicio Rápido_',

    'ATG改造和安装指南': 'ATG Retrofit And Installation Guide',
    '1-1-4-2-1': '1-1-4-2-1 Automatic Tank Gauge for DEF tanks Installation Guide',
    '1-1-4-2-2': '1-1-4-2-2 Automatic Tank Gauge for LPG tanks Installation Guide',
    '1-1-4-2-3': '1-1-4-2-3 Wired ATG Installation Guide-20251125',
    '1-1-4-2-4': '1-1-4-2-4 Automatic Tank Gauge Installation Guide',
    '1-1-4-2-6': '1-1-4-2-6 Guidance for changing the ATGs grounding method to the single tank shielding layer grounding method',
    '1-1-4-2-7': '1-1-4-2-7 Automatic Tank Gauges Probe Installation Guide for Lubricant',
    '1-1-4-2-8': '1-1-4-2-8 Wireless ATG Installation Guide-20250930',
    '1-1-4-2-9': '1-1-4-2-9 The operation of installing the button cell',
    '1-1-4-2-10': '1-1-4-2-10 Differential pressure level gauge installation and operation guide V1.1-20240829 EN',
    '1-1-4-3-1-1': '1-1-4-3-1-1 Probe length calculation drawing',
    '1-1-4-3-1-2': '1-1-4-3-1-2 Probe length table',
    '1-1-4-3-2-2': '1-1-4-3-2-2 Wired ATG Field Construction and Retrofit Guide',
    '1-1-4-3-2-3': '1-1-4-3-2-3 Wireless ATG Field Construction and Retrofit Guide V1.0 20250415',
    'B——3': "B——3'' B-type riser cover(NPT pipe thread)-Model",
    'N——3': "N——3'' N-type riser cover(G pipe thread)-Model",
    'riser': 'riser cap-2024.11.06',

    'ATG维护指南': 'ATG Maintenance And Troubleshooting',
    '1-1-7-6-1': '1-1-7-6-1 ATG Maintenance Guide',
    '1-1-7-6-2': '1-1-7-6-2 ATG Troubleshooting Guide',
    '1-1-3-5-2': '1-1-3-5-2 ATG Daily Operations and Maintenance  (pdf)',
    '1-1-3-5-3': '1-1-3-5-3 Automatic Tank Gauges Usage Guidelines',
    '1-1-9-1-1': '1-1-9-1-1 OKet PD-350 Series Consoles Troubleshooting Manual（20230807）',

    'LD系列文档': 'LDS Series Documents',

    'LD操作手册：请参考《ATG操作手册》LD改装及安装指南': 'LDS Operation Manual：Please refer to 《ATG Operation Manual》 LDS Retrofit and Installation Guide',

    'LD改造和安装指南': 'LDS Retrofit And Installation Guide',
    '1-2-4-1-1': '1-2-4-1-1 Dispenser Pan Leak Detection Sensor Installation Guide DPLS-1 and DPLS-2C',
    '1-2-4-1-2': '1-2-4-1-2 Double-wall tank gap leak Detection sensor Installation Guide SFLS-2F',
    '1-2-4-1-3': '1-2-4-1-3 Double Wall Pipeline Leak Detection Sensor Installation Guide DLLS-2DA and DLLS-2C ',
    '1-2-4-1-4': '1-2-4-1-4 FRP-Steel Double-wall Tank Leak Detection Sensor Installation Guide SFLS-2DA SFLS-2C ',
    '1-2-4-1-5': '1-2-4-1-5 FRP Double-wall Tank Leak  Detection Sensor Installation Guide HLS-1D',
    '1-2-4-1-6': '1-2-4-1-6 Manhole Well Leak Detection Sensor Installation Guide--CSLS-1',
    '1-2-4-1-7': '1-2-4-1-7 Tank Containment Sump Leak Detection Sensor Installation Guide---FSLS-1',
    '1-2-4-1-9': '1-2-4-1-9 Tank vacuum leak sensor installation guide---vtls-1',

    'LD维护指南': 'LDS Maintenance Guide',
    '1-2-7-1': '1-2-7-1 Leak Sensor Modification Address Operation Instructions',

    'HSSE要求': 'HSSE Requirements',
    'OKet HSSE管理体系要求V202306': 'OKet HSSE Management System Requirements V202306',

    '工具清单和收据模板': 'Tool List And Receipt Template',
    '1-1-4-4-1': '1-1-4-4-1 Installation Tool List for ATG and LDS',
    '1-1-4-4-2': '1-1-4-4-2 Automatic Tank Gauges Installation Acceptance Form ',
    '1-1-5-1-1': "1-1-5-1-1 OKet's ATG Order needs to be clear",
    '1-1-5-1-2': "1-1-5-1-2 OKet's ATG Order needs to be clear（wireless)",
    '1-1-5-2-1': '1-1-5-2-1 ATG 2 inches Packing List & Acceptance Form',
    '1-1-5-2-2': '1-1-5-2-2 ATG 3 inches Packing List & Acceptance Form',
    '1-1-5-2-3': '1-1-5-2-3 ATG(wireless) Packing List & Acceptance Form',
    '1-2-5-1-1': '1-2-5-1-1 CSLS-1 Packing List & Acceptance Form',
    '1-2-5-1-2': '1-2-5-1-2  Packing List & Acceptance Form',
    '1-2-5-1-3': '1-2-5-1-3  DPLS-1 Packing List & Acceptance Form',
    '1-2-5-1-4': '1-2-5-1-4  FSLS-1Packing List & Acceptance Form',
    '1-2-5-2': '1-2-5-2 Leak Detection Integrated Installation Acceptance Form '
  },
  exam: {
    '题目': 'Sujet',
    '题目类别': 'Catégorie Sujet',
    '题目答案': 'Question Réponse',
    '答案解析': 'Analyse Réponses',
    '暂无解析': 'Pas Encore Résolution',
    '序号': 'Numéro Série',
    '题目内容': 'Contenu Sujet',
    '题目配图': 'Image Sujet',
    '暂无': 'Pas Encore',
    '操作': 'Fonctionner',
    '删除': 'Supprimer',
    '选项A': 'Variante A',
    '选项B': 'Variante B',
    '选项C': 'Variante C',
    '选项D': 'Variante D',
    '选项E': 'Variante E',
    '选项F': 'Variante F',
    '选项G': 'Variante G',
    '添加题目': 'Ajouter Sujet',
    '编辑题目': 'Modifier Sujet',
    '确认添加': "Confirmer l'ajout",
    '确认编辑': 'Confirmer Modification',
    '选项A为必填项': "L'option A est requise",
    '选项B为必填项': "L'option B est requise",
    '选项C为必填项': "L'option C est requise",
    '请选择题目类型': 'Veuillez sélectionner un type de sujet',
    '题目内容为必填项': 'Le contenu du sujet est requis',
    '题目答案为必填项': 'La réponse à la question est obligatoire',
    'ATG安装': 'Installation ATG',
    'LDS安装': 'Installation LDS',
    '保存成功': 'Enregistré avec succès',
    '保存失败': 'Echec de la sauvegarde',
    '确定删除该题目吗': 'Voulez-vous vraiment supprimer cette question ?',
    '删除成功': 'Supprimé avec succès',
    '删除失败': 'Impossible de supprimer',
    '正确': 'Correct',
    '错误': 'Erreur',
    '组织员工': 'Organiser Personnel',
    '员工': 'Personnel',
    '证书类别': 'Type Certificat',
    '证书下载': 'Téléchargement Certificat',
    '员工列表查询失败': 'Échec de la requête de la liste des employés',
    '资质证书': 'Certificats',
    '证书有效期': 'Validité Certificat',
    '试卷类别': 'Catégorie Papier Test',
    '考试结果': 'Résultat Test',
    '再次考试': 'Réexaminer',
    '合格': 'Qualifié',
    '不合格': 'Sans Réserve',
    '生成试卷失败': 'Échec de la génération du papier test',
    '考试开始时间': "Heure Début de L'examen",
    '考试结束时间': "Heure Fin L'examen",
    '考试进行中': 'Examen En Cours',
    '技能类别': 'Catégorie Compétences',
    '标签中文名称': "Nom chinois de l'étiquette",
    '标签英文名称': "Nom anglais de l'étiquette",
    '标签西班牙名称': 'Etiquette Nom Espagnol',
    '标签法语名称': 'Etiquette Nom Français',
    '请选择技能类别': 'Veuillez sélectionner une catégorie de compétences',
    '请输入标签中文名称': "Veuillez saisir le nom chinois de l'étiquette",
    '请输入标签英文名称': 'Veuillez saisir le nom anglais du label',
    '请输入标签西班牙名称': 'Veuillez saisir un nom espagnol pour le tag',
    '请输入标签法语名称': 'Veuillez saisir le nom français du label',
    '返回': 'Retour',
    '公告标题': 'Titre Du Bulletin',
    '公告内容': "Contenu De L'annonce",
    '公告标题(中文)': 'Titre Du Bulletin(Chinois)',
    '公告内容(中文)': "Contenu De L'annonce(Chinois)",
    '公告标题(英文)': 'Titre Du Bulletin(Anglais)',
    '公告内容(英文)': "Contenu De L'annonce(Anglais)",
    '公告标题(西班牙)': 'Titre Du Bulletin(Espagnol)',
    '公告内容(西班牙)': "Contenu De L'annonce(Espagnol)",
    '公告标题(法语)': 'Titre Du Bulletin(Français)',
    '公告内容(法语)': "Contenu De L'annonce(Français)",
    '请输入公告标题(中文)': "Veuillez entrer le titre de l'annonce(Chinois)",
    '请输入公告内容(中文)': "Veuillez entrer le contenu de l'annonce(Chinois)",
    '请输入公告标题(英文)': "Veuillez entrer le titre de l'annonce(Anglais)",
    '请输入公告内容(英文)': "Veuillez entrer le contenu de l'annonce(Anglais)",
    '请输入公告标题(西班牙)': "Veuillez entrer le titre de l'annonce(Espagnol)",
    '请输入公告内容(西班牙)': "Veuillez entrer le contenu de l'annonce(Espagnol)",
    '请输入公告标题(法语)': "Veuillez entrer le titre de l'annonce(Français)",
    '请输入公告内容(法语)': "Veuillez entrer le contenu de l'annonce(Français)",
    '发布时间': 'Temps De Libération',
    '已读': 'Ont Lu',
    '未读': 'Non Lu',
    '记录阅读状态失败': "Échec de l'état de lecture de l'enregistrement",
    'ATG安装技师考试': "Examen de technicien d'installation ATG",
    'LDS安装技师考试': "Examen de technicien d'installation LDS",
    '参加考试': "Passer L'examen",
    '退出': 'Arrêter',
    '答题卡': 'Feuille Réponses',
    '考试日期': "Date L'examen",
    '考试时长': "Durée L'examen",
    '分钟': 'Minute',
    '单选题': 'Radio',
    '分': 'Indiquer',
    '多选题': 'Choix Multiple',
    '判断题': 'Juge',
    '无': 'Aucun',
    '上一题': 'Question Précédente',
    '下一题': 'Question Suivante',
    '提交试卷': 'Soumettre Papier Test',
    '已完成': 'Complété',
    '每题': 'Par Question',
    '加载中': 'Chargement',
    '获取试卷详情失败': "Impossible d'obtenir les détails du papier test",
    '交卷时间已到，系统将帮您自动交卷': 'Le temps de remise du papier est écoulé, le système remettra automatiquement le papier pour vous',
    '交卷失败，数据库错误，请重新开始考试': "Échec de la soumission, erreur de base de données, veuillez redémarrer l'examen",
    '确定要提交试卷吗': 'Êtes-vous sûr de vouloir soumettre le test papier ?',
    '尚未完成所有题目，确定要提交试卷吗': "Vous n'avez pas répondu à toutes les questions, êtes-vous sûr de vouloir soumettre le test papier",
    '自动计算成绩中': 'Calcul automatique des notes',
    '提交成功': 'Soumis avec succès',
    '系统将自动提交试卷，请确认是否离开考试': 'Le système soumettra automatiquement le document de test, veuillez confirmer si vous souhaitez quitter le test',
    '退出考试，系统已自动提交试卷': 'Quittez le test, le système a automatiquement soumis le papier de test',
    '可到记录页面查看成绩': "Accédez à la page d'enregistrement pour afficher les résultats",
    '试卷详情': "Détails L'examen",
    '试卷类型': 'Type Papier',
    '全部题数': 'Toutes Les Questions',
    '道': 'question',
    '试卷总分': 'Score Total',
    '及格标准': 'Passer Norme',
    '题型介绍': 'Introduction Aux Types Questions',
    '考试说明': "Description L'examen",
    '开始考试': "Commencer L'examen",
    '确定开始考试吗': 'Êtes-vous sûr de vouloir commencer le test ?',
    '请开始作答': 'Merci de commencer à répondre',
    '视频类别': 'Catégorie Vidéo',
    '视频名称': 'Nom De La Vidéo',
    '视频封面': 'Couverture Vidéo',
    '视频文件': 'Fichier Vidéo',
    '视频名称(英文)': 'Nom De La Vidéo(Anglais)',
    '视频封面(英文)': 'Couverture Vidéo(Anglais)',
    '视频文件(英文)': 'Fichier Vidéo(Anglais)',
    '视频名称(中文)': 'Nom De La Vidéo(Chinois)',
    '视频封面(中文)': 'Couverture Vidéo(Chinois)',
    '视频文件(中文)': 'Fichier Vidéo(Chinois)',
    '视频名称(西班牙)': 'Nom De La Vidéo(Espagnol)',
    '视频封面(西班牙)': 'Couverture Vidéo(Espagnol)',
    '视频文件(西班牙)': 'Fichier Vidéo(Espagnol)',
    '视频名称(法语)': 'Nom De La Vidéo(Français)',
    '视频封面(法语)': 'Couverture Vidéo(Français)',
    '视频文件(法语)': 'Fichier Vidéo(Français)',
    '请输入视频名称(英文)': 'Veuillez entrer un nom de vidéo(Anglais)',
    '请选择视频类别': 'Veuillez sélectionner une catégorie de vidéo',
    '全部': 'Tous',
    '查询视频标签数据失败': 'Échec de la requête des données de balise vidéo',
    '图片大小不能超过2MB': "La taille de l'image ne peut pas dépasser 2 Mo",
    '当前限制选择 1 个文件': 'Limite actuelle pour sélectionner 1 fichier',
    '点击下载': 'cliquez pour télécharger',
    '题型单选题': 'Radio ',
    '题型多选题': 'Choix Multiple ',
    '题型判断题': 'Juge ',
    '题型道': ' Questions',
    '题型每题': ' Par Question ',
    '题型分': ' Indiquers',
    '上传文件只能是mp4格式': "Les fichiers téléchargés ne peuvent être qu'au format .mp4",
    '请上传视频封面(英文)': 'Veuillez télécharger la couverture vidéo(Anglais)',
    '请上传视频文件(英文)': 'Veuillez télécharger un fichier vidéo(Anglais)',
    '上传头像图片只能是JPG/JPEG/PNG格式': "La photo de profil téléchargée ne peut être qu'au format JPG/JPEG/PNG",
    '下载失败': 'Échec du téléchargement'
  }
}



// WEBPACK FOOTER //
// ./src/lang/fr.js